import { QueryClient, QueryCache, MutationCache } from "@tanstack/react-query";
import { vaultKeys } from "../hooks/vault/queryKeys";

const VERIFICATION_KEY_PREFIX = vaultKeys.verification();

function isVerificationMutation(mutationKey: unknown): boolean {
  return (
    Array.isArray(mutationKey) &&
    VERIFICATION_KEY_PREFIX.every((segment, i) => mutationKey[i] === segment)
  );
}

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 5 * 60_000,
      gcTime: 30 * 60_000,
      retry: (failureCount, error) => {
        const status = (error as any)?.response?.status;

        if (status && status >= 400 && status < 500) {
          return false;
        }

        if (failureCount >= 3) {
          return false;
        }

        return true;
      },
      retryDelay: (attemptIndex) => {
        return Math.min(1000 * 2 ** attemptIndex, 30000);
      },
    },
  },
  queryCache: new QueryCache({
    onError: (error) => {
      console.error("Query error:", error);
    },
  }),
  mutationCache: new MutationCache({
    onSuccess: (_data, _variables, _context, mutation) => {
      if (isVerificationMutation(mutation.options.mutationKey)) {
        queryClient.invalidateQueries({ queryKey: vaultKeys.folders() });
      }
    },
    onError: (error, _variables, _context, mutation) => {
      if (isVerificationMutation(mutation.options.mutationKey)) {
        console.error("Verification mutation failed globally:", error);
      } else {
        console.error("Mutation error:", error);
      }
    },
  }),
});
